import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UnlockTwoToneSvg from "@ant-design/icons-svg/es/asn/UnlockTwoTone";
import AntdIcon from "../components/AntdIcon";
var UnlockTwoTone = function UnlockTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UnlockTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UnlockTwoTone.displayName = 'UnlockTwoTone';
}
export default /*#__PURE__*/React.forwardRef(UnlockTwoTone);